"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme) {
  var palette = theme.palette,
      periodTailsAfter = {
    display: 'block',
    content: '""',
    position: 'absolute',
    width: '18px',
    height: '50px',
    background: theme.periodBackground,
    left: '-18px'
  },
      date = {
    color: theme.dateColor,
    fontSize: theme.dateFontSize,
    lineHeight: '40px',
    textAlign: 'center',
    padding: '5px',
    boxSizing: 'border-box',
    // line height + padding
    width: '50px',
    height: '50px',
    margin: '0 auto',
    zIndex: 2,
    position: 'relative',
    userSelect: 'none',
    borderRadius: '50%',
    transitionProperty: 'background, color',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    background: theme.dateBackground,
    '&:hover': {
      cursor: 'pointer',
      color: theme.dateColorHover,
      background: theme.dateBackgroundHover
    },
    '&:active': {
      color: theme.dateColorActive,
      background: theme.dateBackgroundActive
    }
  },
      period = {
    background: theme.periodBackground,
    boxSizing: 'border-box',
    width: '100%',
    height: '50px',
    position: 'absolute'
  };
  return {
    root: {
      font: "".concat(palette.tsNormal, "/").concat(palette.tlSmall, " \"").concat(palette.fontFamily, "\""),
      background: theme.background,
      border: "1px solid ".concat(theme.borderColor),
      color: theme.color,
      boxShadow: theme.boxShadow,
      width: '272px',
      boxSizing: 'border-box',
      zIndex: theme.zIndex
    },
    calendar: {
      '& table': {
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0
      }
    },
    calendarHead: {
      borderBottom: "1px solid ".concat(theme.borderColor),
      padding: '9px 18px'
    },
    calendarBody: {
      padding: '0 9px 18px 9px',
      width: '270px',
      boxSizing: 'border-box'
    },
    calendarFooter: {
      paddingTop: palette.gutter * 3 + 'px',
      textAlign: 'right'
    },
    calendarBtnCancel: {
      marginRight: palette.gutter + 'px',
      display: 'inline-block'
    },
    dateWrapper: {
      border: '0 none',
      padding: '5px 0',
      position: 'relative',
      width: '84px',
      boxSizing: 'border-box'
    },
    control: {
      border: '0 none',
      position: 'relative',
      boxSizing: 'border-box',
      fontSize: theme.headFontSize,
      lineHeight: theme.headLineHeight,
      textAlign: 'center',
      padding: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    controlIcon: {
      display: 'flex'
    },
    controlYear: {
      // equal to arrows
      lineHeight: palette.gutter * 3 + 'px'
    },
    date: date,
    dateToday: _objectSpread({}, date, {
      color: theme.dateTodayColor,
      background: theme.dateTodayBackground
    }),
    dateDisabled: _objectSpread({}, date, {
      color: theme.dateDisabledColor,
      background: theme.dateDisabledBackground,
      cursor: 'not-allowed',
      '&:hover': {
        color: theme.dateDisabledColor,
        background: theme.dateDisabledBackground
      },
      '&:active': {
        color: theme.dateDisabledColor,
        background: theme.dateDisabledBackground
      }
    }),
    datePassive: _objectSpread({}, date, {
      '&:hover': {
        background: 'transparent'
      }
    }),
    dateSelected: _objectSpread({}, date, {
      color: theme.dateSelectedColor,
      background: theme.dateSelectedBackground,
      '&:hover': {
        color: theme.dateSelectedColor,
        background: theme.dateSelectedBackground
      },
      '&:active': {
        color: theme.dateSelectedColor,
        background: theme.dateSelectedBackground
      }
    }),
    period: period,
    periodStart: _objectSpread({}, period, {
      borderBottomLeftRadius: '50%',
      borderTopLeftRadius: '50%',
      width: '50px',
      left: '16px',
      '&:after': _objectSpread({}, periodTailsAfter, {
        right: '-18px',
        left: 'auto'
      })
    }),
    periodEnd: _objectSpread({}, period, {
      borderBottomRightRadius: '50%',
      borderTopRightRadius: '50%',
      width: '50px',
      right: '16px',
      '&:after': _objectSpread({}, periodTailsAfter)
    }),
    periodNoFill: _objectSpread({}, period, {
      background: 'transparent',
      '&:after': {
        display: 'none'
      }
    })
  };
}